'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _lodash = require('lodash');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _reactFontawesome = require('react-fontawesome');

var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function NavList(props) {
	var handleMouseEnter = props.handleMouseEnter,
	    itemContent = props.itemContent,
	    handleItemClick = props.handleItemClick,
	    type = props.type,
	    isActiveLv3 = props.isActiveLv3,
	    isSelected = props.isSelected,
	    itemIndex = props.itemIndex,
	    onURLClick = props.onURLClick,
	    isExpand = props.isExpand,
	    textColorClass = props.textColorClass,
	    fullURL = props.fullURL;

	var _useState = (0, _react.useState)(itemContent.color),
	    _useState2 = _slicedToArray(_useState, 2),
	    color = _useState2[0],
	    setColor = _useState2[1];

	var _useState3 = (0, _react.useState)(itemContent.bgColor),
	    _useState4 = _slicedToArray(_useState3, 2),
	    bgColor = _useState4[0],
	    setBgColor = _useState4[1];

	var cLang = _i18next2.default.language;

	return _react2.default.createElement(
		'li',
		{
			className: 'nav-item  text-left'
			// onTouchEnd={()=>{}} 
			, onMouseEnter: isActiveLv3 ? handleItemClick : null,
			onMouseLeave: isActiveLv3 ? handleItemClick : null
		},
		_react2.default.createElement(
			'a',
			{
				className: textColorClass + ' sec-nav-item nav-link languageAnimation ' + (isActiveLv3 ? 'nav-no-hover' : ''),
				href: fullURL,
				onClick: function onClick(e) {
					e.preventDefault();onURLClick(itemContent.url, 'subNav2');
				},
				style: {
					color: color + ' !important',
					backgroundColor: bgColor
					// fontSize: "20px",
					// fontWeight: cLang == "en-US" ? 300 : 400
				},
				onMouseEnter: function onMouseEnter(e) {
					setColor(itemContent.hoverColor);setBgColor(itemContent.hoverBgColor);handleMouseEnter(itemContent);
				},
				onMouseLeave: function onMouseLeave(e) {
					setColor(itemContent.color);setBgColor(itemContent.bgColor);
				}
			},
			(0, _reactHtmlParser2.default)(itemContent.title),
			isActiveLv3 && _react2.default.createElement(
				_react2.default.Fragment,
				null,
				'\xA0\xA0',
				_react2.default.createElement(
					'span',
					null,
					_react2.default.createElement(_reactFontawesome2.default, { name: isSelected || isExpand ? 'caret-down' : 'caret-right' })
				)
			)
		),
		isActiveLv3 && _react2.default.createElement(
			_react2.default.Fragment,
			null,
			props.children
		)
	);
}

exports.default = NavList;